import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Secao from '../../components/ui/Secao';
import { notasEntradaApi } from '../../api/compras';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

export default function NotaEntradaDetail({ notaEntradaId, onVoltar }) {
  const [nota, setNota] = useState(null);

  useEffect(() => { notasEntradaApi.obter(notaEntradaId).then(setNota).catch(() => {}); }, [notaEntradaId]);

  useTituloPagina(nota ? `Nota de Entrada — NF ${nota.numero || ''}` : 'Nota de Entrada');

  if (!nota) return null;

  return (
    <div>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, borderBottom: `1px solid ${COLORS.border}`, paddingBottom: 14 }}>
          <strong style={{ fontSize: 15 }}>{nota.fornecedor_nome} — Ordem de Compra #{nota.ordem_compra_numero}</strong>
          <Btn variante="ghost" onClick={onVoltar}>Voltar</Btn>
        </div>

        <Secao titulo="Dados da Nota">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, fontSize: 13 }}>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Número</div>{nota.numero || '-'}</div>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Série</div>{nota.serie || '-'}</div>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Data de Emissão</div>{nota.data_emissao ? new Date(nota.data_emissao).toLocaleDateString('pt-BR') : '-'}</div>
            <div><div style={{ color: COLORS.textMid, fontSize: 11 }}>Valor Total</div>R$ {Number(nota.valor_total || 0).toFixed(2)}</div>
            <div style={{ gridColumn: '1 / -1' }}><div style={{ color: COLORS.textMid, fontSize: 11 }}>Chave de Acesso</div>{nota.chave_acesso || '-'}</div>
          </div>
        </Secao>

        <div style={{ height: 14 }} />

        <Secao titulo="Itens">
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', background: COLORS.bg }}>
                <th style={{ padding: 8 }}>Produto</th>
                <th style={{ padding: 8 }}>Cód. Fabricante</th>
                <th style={{ padding: 8 }}>Cód./Descrição na NF</th>
                <th style={{ padding: 8 }}>Quantidade</th>
                <th style={{ padding: 8 }}>Valor Unit.</th>
                <th style={{ padding: 8 }}>Valor Total</th>
              </tr>
            </thead>
            <tbody>
              {nota.itens.map(item => (
                <tr key={item.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                  <td style={{ padding: 8 }}>{item.produto_codigo} - {item.produto_nome}</td>
                  <td style={{ padding: 8 }}>{item.produto_codigo_fabricante || '-'}</td>
                  <td style={{ padding: 8 }}>{item.codigo_nf ? `${item.codigo_nf} — ` : ''}{item.descricao_nf || '-'}</td>
                  <td style={{ padding: 8 }}>{item.quantidade}</td>
                  <td style={{ padding: 8 }}>R$ {Number(item.valor_unitario).toFixed(2)}</td>
                  <td style={{ padding: 8 }}>R$ {Number(item.valor_total).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Secao>
      </Card>
    </div>
  );
}
